import { Env } from '@/consts/Env';

export const APP_VARIANT = {
  DEFAULT: 'default',
  CHRISTMAS: 'christmas',
} as const;

export type AppVariant = typeof APP_VARIANT[keyof typeof APP_VARIANT];

export function byAppVariant<T>(
  variants: { default: T } & Partial<Record<AppVariant, T>> & Record<string, T | undefined>,
): T {
  const variant = Env.NEXT_PUBLIC_APP_VARIANT ?? APP_VARIANT.DEFAULT;

  switch (variant) {
    case APP_VARIANT.CHRISTMAS:
      return (variants[APP_VARIANT.CHRISTMAS] ?? variants.default) as T;
    default:
      return (variants[variant] ?? variants.default) as T;
  }
}
